// @ts-nocheck
// EditToolMenuList: 비디오 편집 도구 메뉴 리스트 컴포넌트
import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import MergeIcon from '@mui/icons-material/Merge';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import CropIcon from '@mui/icons-material/Crop';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const MENU_LIST = [
    {
        key: 'cut',
        icon: <ContentCutIcon className="edit-tool-menu-list__arrow-icon" />,
        label: (t) => t('vod.manage.editor_tab.cut'),
        width: '25%',
    },
    {
        key: 'concat',
        icon: <MergeIcon className="edit-tool-menu-list__arrow-icon" />,
        label: (t) => t('vod.manage.editor_tab.merge'),
        width: '10%',
    },
    {
        key: 'watermark',
        icon: <BrandingWatermarkIcon className="edit-tool-menu-list__arrow-icon" />,
        label: (t) => t('vod.manage.editor_tab.watermark'),
        width: '25%',
    },
    {
        key: 'crop',
        icon: <CropIcon className="edit-tool-menu-list__arrow-icon" />,
        label: (t) => t('vod.manage.editor_tab.crop'),
        width: '25%',
    },
];

const EditToolMenuList = ({ activeTool, setEditTool, hasSaved, t }) => {
    return (
        <>
            {MENU_LIST.map((item) => {
                const isOpen = activeTool === item.key;
                const isRoot = activeTool === '';
                const isSaved = hasSaved[item.key];
                return (
                    (isRoot || isOpen) && (
                        <Stack
                            key={item.key}
                            direction="row"
                            alignItems="center"
                            className='list-edit-tool'
                            style={{
                                cursor: isRoot ? 'pointer' : 'default',
                                backgroundColor: isRoot && isSaved ? '#fff3cd' : 'transparent',
                                borderLeft: isRoot && isSaved ? '4px solid #ffc107' : 'none'
                            }}
                            onClick={() => {
                                if (isRoot) setEditTool(item.key);
                                else if (isOpen) setEditTool('');
                            }}
                        >
                            <Box className="edit-tool-menu-list__icon-container">
                                {React.cloneElement(item.icon, { color: isRoot && isSaved ? 'warning' : 'inherit' })}
                            </Box>
                            <Box className="edit-tool-menu-list__label-container">
                                <Typography className={isRoot && isSaved ? 'edit-tool-menu-list__saved-label' : ''}>
                                    {item.label(t)}
                                </Typography>
                            </Box>
                            <Box className="edit-tool-menu-list__content-container">
                                {item.key === 'concat' && isOpen && (
                                    <Typography variant="caption" color="text.secondary">
                                        {t('vod.manage.editor_tab.cut_warning')}
                                    </Typography>
                                )}
                                {isRoot && isSaved && (
                                    <Typography variant="caption" color="warning.main" className="edit-tool-menu-list__edited-text">
                                        {t('vod.manage.editor_tab.edited')}
                                    </Typography>
                                )}
                            </Box>
                            <Box className="edit-tool-menu-list__arrow-container">
                                {isOpen
                                    ? (item.key === 'concat' ? <KeyboardArrowUpIcon className="edit-tool-menu-list__arrow-icon" /> : null)
                                    : <KeyboardArrowDownIcon className="edit-tool-menu-list__arrow-icon" />}
                            </Box>
                        </Stack>
                    )
                );
            })}
        </>
    );
};

export default EditToolMenuList; 